// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
import { inject, Injectable } from '@angular/core';
import type { Translation, TranslocoLoader, TranslocoService, TranslocoTestingOptions } from '@jsverse/transloco';
import { getBrowserLang, TranslocoTestingModule } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';
import { environment } from './environments/environment.china';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    //return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    return this.http.get<Translation>(
      environment.staticUrl + `/i18n/sara/${environment.production ? lang : 'dev/' + lang}.json`,
    );
  }
}

export function getTranslocoModule(options: TranslocoTestingOptions = {}) {
  return TranslocoTestingModule.forRoot({
    translocoConfig: {
      availableLangs: ['en', 'es'],
      defaultLang: 'en',
    },
    preloadLangs: true,
    ...options,
  });
}

export const preloadUser =
  (transloco: TranslocoService): unknown =>
  (): Promise<Record<string, unknown>> => {
    let language: string | null | undefined = localStorage.getItem('language') ?? 'en';
    if (language) transloco.setActiveLang(language);
    else {
      language = getBrowserLang();
      if (language) {
        if (language.includes('zh')) language = 'zh-CN';

        transloco.setActiveLang(language);
        localStorage.setItem('language', language);
      }
    }
    return firstValueFrom(transloco.load(language as string));
  };
